import { useOrchestratorApi } from '@/api/orchestrator'
import type { PostWorkflow, TokenDecoded, Mode } from '@/types'
import decode from 'jwt-decode'
import { readonly, ref } from 'vue'

const token = ref<string>()
const decodedToken = ref<TokenDecoded>()
const workflowId = ref<string>()
const partyId = ref<string>()
const mode = ref<Mode>('staging')

export const useWorkspace = () => {
    const getCurrentWorkflow = async (): Promise<PostWorkflow> => {
        const { data } = await useOrchestratorApi().post<PostWorkflow>(
            '/workflows',
            null,
            {
                headers: {
                    Authorization: `Bearer ${token.value}`,
                },
            },
        )

        setWorkflowId(data.id)
        setPartyId(data.caseId)

        return data
    }

    const startWorkflow = async (): Promise<void> => {
        await useOrchestratorApi().put(
            `/workflows/${workflowId.value}`,
            {
                Authorization: `Bearer ${token.value}`,
            },
        )
    }

    const setToken = (value: string): TokenDecoded => {
        decodedToken.value = decode<TokenDecoded>(value)
        token.value = value
        const { environment, partyId } = decodedToken.value
        setMode(environment)
        setPartyId(partyId)

        return decodedToken.value
    }

    const setWorkflowId = (value: string) => {
        workflowId.value = value
    }

    const setPartyId = (value: string) => {
        partyId.value = value
    }

    const setMode = (value: Mode) => {
        mode.value = value
    }


    return {
        token: readonly(token),
        decodedToken: readonly(decodedToken),
        workflowId: readonly(workflowId),
        mode: readonly(mode),
        setToken,
        setWorkflowId,
        setMode,
        getCurrentWorkflow,
        startWorkflow,
    }
}
